// extracted by mini-css-extract-plugin
export default {"wrapper":"qx-z","addressLine":"rx-z","fullName":"sx-z"};